import { render, staticRenderFns } from "./PropostaEnviada.vue?vue&type=template&id=5cae9834&scoped=true&"
import script from "./PropostaEnviada.vue?vue&type=script&lang=js&"
export * from "./PropostaEnviada.vue?vue&type=script&lang=js&"
import style0 from "./PropostaEnviada.vue?vue&type=style&index=0&id=5cae9834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae9834",
  null
  
)

export default component.exports